export const ROBOTS_NOINDEX_FOLLOW = "noindex,follow";
export const ROBOTS_NOINDEX_NOFOLLOW = "noindex,nofollow";

export type RobotsDirective =
  | typeof ROBOTS_NOINDEX_FOLLOW
  | typeof ROBOTS_NOINDEX_NOFOLLOW;

const NOFOLLOW_PATH_PREFIXES = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/register",
  "/admin",
  "/checkout",
  "/account",
  "/verify",
  "/invite",
  "/newsletter/preferences",
  "/coming-soon",
  "/api",
  "/bff",
  "/reverse-geocode",
  "/healthz",
];

function normalizePathname(pathname: string): string {
  const withLeadingSlash = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const normalized = withLeadingSlash
    .replace(/\/{2,}/g, "/")
    .replace(/\/+$/, "");
  return normalized || "/";
}

export function stripGermanLocalePrefix(pathname: string): string {
  const normalized = normalizePathname(pathname);
  if (normalized.toLowerCase() === "/de") return "/";
  if (normalized.toLowerCase().startsWith("/de/"))
    return normalized.slice(3) || "/";
  return normalized;
}

function matchesPathPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

function hasTokenQuery(searchParams: URLSearchParams): boolean {
  return [...searchParams.keys()].some((key) => key.toLowerCase() === "token");
}

export function getRobotsDirective(
  location: string | URL,
): RobotsDirective | undefined {
  const url =
    location instanceof URL
      ? location
      : new URL(location, "https://robots-policy.invalid");
  const pathname = stripGermanLocalePrefix(url.pathname).toLowerCase();

  const isEventPath = /^\/establishment\/[^/]+\/event\/[^/]+(?:\/|$)/.test(
    pathname,
  );
  if (isEventPath && hasTokenQuery(url.searchParams)) {
    return ROBOTS_NOINDEX_NOFOLLOW;
  }

  if (
    NOFOLLOW_PATH_PREFIXES.some((prefix) => matchesPathPrefix(pathname, prefix))
  ) {
    return ROBOTS_NOINDEX_NOFOLLOW;
  }

  if (matchesPathPrefix(pathname, "/search")) {
    return ROBOTS_NOINDEX_FOLLOW;
  }

  const isEstablishmentNewsletter =
    /^\/establishment\/[^/]+\/newsletter(?:\/|$)/.test(pathname);
  if (isEstablishmentNewsletter) {
    return ROBOTS_NOINDEX_FOLLOW;
  }

  return undefined;
}
